import {Component, ElementRef, EventEmitter, Input, Output} from '@angular/core';
import {Severity} from '../../../../types/severity';
import {NotificationStatus} from '../../../../types/notifications.type';

@Component({
  selector: 'mc-notification-item',
  templateUrl: './notification-item.component.html',
  styleUrls: ['./notification-item.component.scss'],
})
export class NotificationItemComponent {
  @Input() severity: Severity = 'primary';
  @Input() status: NotificationStatus;
  @Output() read = new EventEmitter();
  expanded = true;
  minItemHeight = 62; // minimal height for notification with content in one line
  notificationStatus = NotificationStatus;
  constructor(private notificationContent: ElementRef) {}

  get notificationNotReaded() {
    return this.status && this.status === NotificationStatus.NEW;
  }
  get notificationDismiss() {
    return this.status && this.status === NotificationStatus.DISMISS;
  }

  get showExpandIcon(): boolean {
    if (!this.notificationContent) return false;
    const elementHeight = this.notificationContent.nativeElement.offsetHeight;
    return elementHeight >= this.minItemHeight;
  }

  onClickAction(event: Event, status: NotificationStatus) {
    event.stopPropagation();
    this.read.emit(status);
  }
  onExpandAction(event: Event) {
    event.stopPropagation();
    this.expanded = !this.expanded;
  }
}
